export default __webpack_public_path__ + "static/media/dardi.a6dd1883.png";